jQuery($ => {
    console.log("loonar.io");

    // SVGInject
    SVGInject.setOptions({
        onFail: function(img) {
          img.classList.remove('injectable');
        }
    });

    SVGInject(document.querySelectorAll("img.injectable"));

    function renderNewsBox(newsBox, isCalendarEvent) {
        if (!isCalendarEvent) {
            newsBox.each((index, news) => {
                const title = $(news).find('.e-news-box__title');
                const desc = $(news).find('.e-news-box__desc');

                const wrapperHeight = $(news).find('.e-news-box__text').height();
                const titleHeight = $(title).outerHeight(true);
                const descHeight = $(desc).outerHeight();
                const height = wrapperHeight - titleHeight;

                if (titleHeight >= wrapperHeight) {
                    const titles = new Dotdotdot($(title)[0], {
                        ellipsis: " [...]",
                        height: wrapperHeight,
                        watch: true,
                        truncate: "word"
                    });
                }

                if (titleHeight < wrapperHeight) {
                    const descriptions = new Dotdotdot($(desc)[0], {
                        ellipsis: " [...]",
                        height,
                        watch: true,
                        truncate: "word",
                    });
                }
            });
        } else {
            newsBox.each((index, news) => {
                const title = $(news).find('.e-news-box__title');
                const desc = $(news).find('.e-news-box__desc');
                const titleHeight = $(title).outerHeight(true);
                const descHeight = $(desc).outerHeight();

                const wrapper = $(news).find('.e-news-box__text');
                const offsetTop = $(wrapper).position().top;
                const wrapperHeight = $(news).height() - offsetTop - 18;
                const height = wrapperHeight - titleHeight;

                if (titleHeight >= wrapperHeight) {
                    const titles = new Dotdotdot($(title)[0], {
                        ellipsis: " [...]",
                        height: wrapperHeight,
                        watch: true,
                        truncate: "word"
                    });
                }

                if (titleHeight < wrapperHeight) {
                    const descriptions = new Dotdotdot($(desc)[0], {
                        ellipsis: " [...]",
                        height,
                        watch: true,
                        truncate: "word",
                    });
                }
            });
        }
    }

    $('[data-fancybox="gallery"]').fancybox({
        infobar: false,
        toolbar: false
    });

    // mobile nav 100vh on mobile browser
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    // mobile nav
    const mobileBtn = $(".e-nav-btn");
    const mobileNav = $(".m-mobile-nav");
    const mobileMenu = $(".m-mobile-nav__list");
    const header = $('header');
    const body = $('body');
    const html = $('html');
    const mainTag = $('main');

    // const setHeight = function() {
    //     const top = header.outerHeight();
    //     mainTag.css({ "padding-top": top + "px" });
    // };
    // setHeight();

    // open and close mobile menu - classes toggler
    mobileBtn.on("click", function(e) {
        let active = $(this).hasClass("active") ? true : false;

        if (active) {
            mobileBtn.removeClass("active");
            mobileNav.removeClass("active");
            body.removeClass("blocked");
            html.removeClass("blocked");
            header.removeClass("active");
        } else {
            mobileBtn.addClass("active");
            mobileNav.addClass("active");
            body.addClass("blocked");
            html.addClass("blocked");
            header.addClass("active");
        }
        return false;
    });

    // mobile nav preventDefault on first element with submenu
    const mobileChild = $(".m-mobile-nav__list .menu-item-has-children > a");
    mobileChild.on("click", function(e) {
        e.preventDefault();
    });

    // resize (remove mobile & fixed)
    $(window).on("resize", function() {
        // setHeight();
        if ($(this).width() >= 992) {
            mobileBtn.removeClass("active");
            mobileNav.removeClass("active");
            header.removeClass("active");
            body.removeClass("blocked");
            html.removeClass("blocked");
            body.css('padding-top', 0);
        }
    });

    // header - add class on scroll
	$(window).on('scroll', function() {
		if ($(this).scrollTop() > 10) {
            header.addClass('m-header--fixed');
		} else {
			header.removeClass('m-header--fixed');
		}
	});

    // fix search and login bar to bottom in mobile menu
    const mobileBottom = $(".m-mobile-bottom");

    mobileNav.on("scroll", function() {
        mobileBottom.css("bottom", -$(this).scrollTop());
    });

    // close all submenus
    function closeAllSubmenus(item) {
        $(".menu-item-has-children").not(item.parent()).removeClass("active");
        $(".menu-item-has-children > a").not(item).removeClass("active");
        $(".sub-menu").not(item.next()).css('max-height', 0).removeClass('active');
    }

    // open submenu
    $(".menu-item-has-children > a").on("click", function(e) {
        if (mobileNav.hasClass('active')) {
            closeAllSubmenus($(this));
            let submenu = $(this).next(".sub-menu");
            $(this).parent().toggleClass("active");
            $(this).toggleClass("active");
            if (submenu.hasClass('active')) {
                submenu.css('max-height', 0);
            } else {
                submenu.css('max-height', $(this).next(".sub-menu").children().length*40);
            }
            submenu.toggleClass('active');
        }
    });

    // searchbar variables
    const submitButton = $('.m-mobile-bottom__trigger');
    const searchInput = $('.m-mobile-bottom__input');
    const loginMenu = $('.m-mobile-bottom__login');
    const searchRealBtn = $(".searchButton");

    // unfocus (blur) searchbar
    searchInput.blur(function() {
        // $(window).scrollTop(0);
        let $this = $(this);
        setTimeout(function() {
            $this.removeClass('active');
            loginMenu.removeClass('unactive');
            searchRealBtn.removeClass('normal-pos');
        }, 1000);
    });

    submitButton.on('click', function() {
        searchInput.addClass('active');
        searchInput.focus();
        loginMenu.addClass('unactive');
    });
    searchInput.on('input focus', function() {
        if ($(this).val().length > 0 ) {
            searchRealBtn.addClass('normal-pos');
        }
    });

    $(window).on("load", function() {
        // Add padding-right to title
        const swiperPagWidth = $(".eventsSwiper-pagination").width();
        const eventsTitle = $(".e-events__title--swiper");
        if ($(window).width() >= 768) {
            eventsTitle.css('padding-right', swiperPagWidth);
        }
    });

    $(window).on('load', function(e) {
        const shortNewsTitle = $('.e-short-news__title');
        shortNewsTitle.each(function(e) {
            let elementHei = $(this).innerHeight();

            if (elementHei > 30) {
                $(this).addClass('e-short-news__title--large');
            }
         });
    });

    const url = new URL(window.location.href);
    let find_param = url.searchParams.get('s') ? url.searchParams.get('s') : false;
    if(!find_param) {
        find_param = url.searchParams.get('find') ? url.searchParams.get('find') : false;
    }

    if(find_param) {

        if ($('.find-highlights').length > 0) {

            $('.find-highlights').each((index, el) => {
                let text = el.innerHTML;

                const re = new RegExp('(' + find_param + ')', "ig");
                text = text.replace(re, '<span class="e-highlight">$1</span>');
                el.innerHTML = text;
            });
        }
    }

    const newsBox = $('.e-news-box');
    if (newsBox.length > 0) {
        if(!newsBox.hasClass('e-news-box--calendar')) {
            renderNewsBox(newsBox, false);
        } else {
            renderNewsBox(newsBox, true);
        }
    }

    $(".scroll_to_section").on('click', function (e) {
        e.preventDefault();
        const section = $(this).attr("href");
        const offset = $('.m-header').outerHeight();
        const adminBarHeight = $('#wpadminbar').length ? $('#wpadminbar').height() : 0;

        $("html, body").animate({
            scrollTop: $(section).offset().top - offset - 20 - adminBarHeight
        });
    });

    $('.m-promotions__grid').masonry({
        itemSelector: '.e-promotion',
        columnWidth: '.m-promotions__grid-sizer',
        percentPosition: true,
        gutter: 0,
    });
});
